import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-super',
  templateUrl: './master-super.component.html',
  styleUrls: ['./master-super.component.scss']
})
export class MasterSuperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
